import { Card } from "@/components/ui/Card";
import FormTable from "./component/table";
import useDocumentTitle from "@/hooks/UseDocumentTitle";

const FormManagement = () => {
  useDocumentTitle("Form Management");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <FormTable />
      </Card>
    </div>
  );
};

export default FormManagement;
